module.exports = __webpack_public_path__ + "media/images/emblems/Pailly-coat_of_arms-6c392149c5de9ced62344dad49463b6d.svg";